import React from 'react';
import { pick } from 'lodash';
import { Link, useParams } from 'react-router-dom';
import { Button } from '@schibsted-svp/react-ui';

import { updateAssetMetadata } from '../services/api/assets';
import { AssetForm } from '../components/AssetForm/AssetForm';
import { useAsset } from '../hooks/useAsset';
import { ContainerHeader } from '../components/Container/ContainerHeader/ContainerHeader';
import { withFetchStatus } from '../services/notifier';

import type { SvpAsset } from '../types';
import type { FC } from 'react';

export const Asset: FC = () => {
  const { assetId } = useParams<{ assetId: string }>();

  const {
    data: entity,
    isFetching,
    refetch,
  } = useAsset(assetId ? parseInt(assetId, 10) : undefined);

  async function onSubmit(asset: SvpAsset) {
    await withFetchStatus(updateAssetMetadata, {
      success: 'Asset updated successfully',
      error: 'Failed to update asset',
    })(
      entity!.id,
      pick(asset.additional?.metadata, [
        'verticalPosterImage',
        'eventStartTime',
        'studioStartTime',
      ]) as Parameters<typeof updateAssetMetadata>[1]
    );

    await refetch();
  }

  if (!entity) {
    return null;
  }

  return (
    <>
      <ContainerHeader>
        <Link to="/assets">
          <Button type="button" variant="standard">
            Back
          </Button>
        </Link>
      </ContainerHeader>

      <AssetForm asset={entity} onSubmit={onSubmit} isLoading={isFetching} />
    </>
  );
};
